import React from 'react';
import { SparklesIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.tiendadigitalonline.com/cart/47950473298161:1';
const BONO_1 = 'https://cdn.magicpatterns.com/uploads/qXQE53n6QmZcRoZMb6SpEZ/mocap_bono_1_sin_fondo.png';
const BONO_2 = 'https://cdn.magicpatterns.com/uploads/1bsEVJJz133BYCpzJw9wkL/mocap_bono_2_sin_fondo.png';
const BONO_3 = 'https://cdn.magicpatterns.com/uploads/uWnzAaG95UbcZ85afzAjeC/mocap_bono_3_sin_fondo.png';
const BONO_4 = 'https://cdn.magicpatterns.com/uploads/8QdAaer2BJnF67eRawUevj/mocap_bono_4_sin_fondo.png';
export function BonusSection() {
  return <section className="w-full bg-white py-16 md:py-20 px-4" data-id="element-53">
      <div className="max-w-4xl mx-auto" data-id="element-54">
        <div className="text-center mb-14" data-id="element-55">
          <span className="inline-block bg-gold-500/10 text-gold-600 font-heading font-bold text-sm uppercase tracking-widest px-4 py-2 rounded-full mb-4" data-id="element-56">
            🎁 GRATIS POR EL DÍA DE HOY
          </span>
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-gray-900" data-id="element-57">
            🎁 BONOS ESPECIALES – GRATIS HOY
          </h2>
        </div>

        <div className="space-y-16" data-id="element-58">
          {/* Bono 1 */}
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-59">
            <a href={CHECKOUT_URL} className="flex-shrink-0 cursor-pointer hover:scale-105 transition-transform duration-300" data-id="element-60">
              <img src={BONO_1} alt="Bono 1 - Diario de Tarot para 30 días" className="w-[300px] h-[300px] md:w-[400px] md:h-[400px] object-contain drop-shadow-xl" data-id="element-61" />
            </a>
            <div className="text-center md:text-left" data-id="element-62">
              <span className="inline-block bg-gold-500 text-black font-heading font-bold text-xs uppercase tracking-wider px-3 py-1 rounded-full mb-3" data-id="element-63">
                Bono #1
              </span>
              <h3 className="font-heading font-bold text-2xl text-gray-900 mb-2" data-id="element-64">
                Diario de Tarot para 30 días
              </h3>
              <p className="font-body text-gray-600 mb-4" data-id="element-65">
                Ejercicios guiados para desarrollar tu intuición día a día.
              </p>
              <p className="font-body text-gray-400 line-through text-sm mb-1" data-id="element-66">
                Valor: ARS $10,000
              </p>
              <p className="font-heading font-bold text-xl text-green-600" data-id="element-67">
                HOY: GRATIS
              </p>
            </div>
          </div>

          <div className="w-full h-px bg-gray-200" data-id="element-68" />

          {/* Bono 2 */}
          <div className="flex flex-col md:flex-row-reverse items-center gap-8" data-id="element-69">
            <a href={CHECKOUT_URL} className="flex-shrink-0 cursor-pointer hover:scale-105 transition-transform duration-300" data-id="element-70">
              <img src={BONO_2} alt="Bono 2 - Guía de Limpieza y Protección Energética" className="w-[300px] h-[300px] md:w-[400px] md:h-[400px] object-contain drop-shadow-xl" data-id="element-71" />
            </a>
            <div className="text-center md:text-left" data-id="element-72">
              <span className="inline-block bg-gold-500 text-black font-heading font-bold text-xs uppercase tracking-wider px-3 py-1 rounded-full mb-3" data-id="element-73">
                Bono #2
              </span>
              <h3 className="font-heading font-bold text-2xl text-gray-900 mb-2" data-id="element-74">
                Guía de Limpieza y Protección Energética
              </h3>
              <p className="font-body text-gray-600 mb-4" data-id="element-75">
                Aprendé a cuidar tu energía y tus lecturas.
              </p>
              <p className="font-body text-gray-400 line-through text-sm mb-1" data-id="element-76">
                Valor: ARS $10,000
              </p>
              <p className="font-heading font-bold text-xl text-green-600" data-id="element-77">
                HOY: GRATIS
              </p>
            </div>
          </div>

          <div className="w-full h-px bg-gray-200" data-id="element-78" />

          {/* Bono 3 */}
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-79">
            <a href={CHECKOUT_URL} className="flex-shrink-0 cursor-pointer hover:scale-105 transition-transform duration-300" data-id="element-80">
              <img src={BONO_3} alt="Bono 3 - Tarot y Manifestación" className="w-[300px] h-[300px] md:w-[400px] md:h-[400px] object-contain drop-shadow-xl" data-id="element-81" />
            </a>
            <div className="text-center md:text-left" data-id="element-82">
              <span className="inline-block bg-gold-500 text-black font-heading font-bold text-xs uppercase tracking-wider px-3 py-1 rounded-full mb-3" data-id="element-83">
                Bono #3
              </span>
              <h3 className="font-heading font-bold text-2xl text-gray-900 mb-2" data-id="element-84">
                Tarot y Manifestación
              </h3>
              <p className="font-body text-gray-600 mb-4" data-id="element-85">
                Usá el Tarot como herramienta para crear tu realidad.
              </p>
              <p className="font-body text-gray-400 line-through text-sm mb-1" data-id="element-86">
                Valor: ARS $10,000
              </p>
              <p className="font-heading font-bold text-xl text-green-600" data-id="element-87">
                HOY: GRATIS
              </p>
            </div>
          </div>

          <div className="w-full h-px bg-gray-200" data-id="element-88" />

          {/* Bono 4 */}
          <div className="flex flex-col md:flex-row-reverse items-center gap-8" data-id="element-89">
            <a href={CHECKOUT_URL} className="flex-shrink-0 cursor-pointer hover:scale-105 transition-transform duration-300" data-id="element-90">
              <img src={BONO_4} alt="Bono 4 - Mazo de Tarot Imprimible" className="w-[300px] h-[300px] md:w-[400px] md:h-[400px] object-contain drop-shadow-xl" data-id="element-91" />
            </a>
            <div className="text-center md:text-left" data-id="element-92">
              <span className="inline-block bg-gold-500 text-black font-heading font-bold text-xs uppercase tracking-wider px-3 py-1 rounded-full mb-3" data-id="element-93">
                Bono #4
              </span>
              <h3 className="font-heading font-bold text-2xl text-gray-900 mb-2" data-id="element-94">
                Mazo de Tarot Imprimible
              </h3>
              <p className="font-body text-gray-600 mb-4" data-id="element-95">
                Tu propio mazo listo para usar desde hoy.
              </p>
              <p className="font-body text-gray-400 line-through text-sm mb-1" data-id="element-96">
                Valor: ARS $10,000
              </p>
              <p className="font-heading font-bold text-xl text-green-600" data-id="element-97">
                HOY: GRATIS
              </p>
            </div>
          </div>

          <div className="w-full h-px bg-gray-200" data-id="element-98" />

          {/* Bono 5 */}
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-99">
            <a href={CHECKOUT_URL} className="flex-shrink-0 cursor-pointer hover:scale-105 transition-transform duration-300" data-id="element-100">
              <img src="https://cdn.magicpatterns.com/uploads/5T43JfWtWpFDXiCuQjuKg4/mocap_bono_5_sin_fondo.png" alt="Bono 5 - Meditación Guiada" className="w-[300px] h-[300px] md:w-[400px] md:h-[400px] object-contain drop-shadow-xl" data-id="element-101" />
            </a>
            <div className="text-center md:text-left" data-id="element-102">
              <span className="inline-block bg-gold-500 text-black font-heading font-bold text-xs uppercase tracking-wider px-3 py-1 rounded-full mb-3" data-id="element-103">
                Bono #5
              </span>
              <h3 className="font-heading font-bold text-2xl text-gray-900 mb-2" data-id="element-104">
                Meditación Guiada
              </h3>
              <p className="font-body text-gray-600 mb-4" data-id="element-105">
                Conectá con tu intuición y energía interna.
              </p>
              <p className="font-body text-gray-400 line-through text-sm mb-1" data-id="element-106">
                Valor: ARS $10,000
              </p>
              <p className="font-heading font-bold text-xl text-green-600" data-id="element-107">
                HOY: GRATIS
              </p>
            </div>
          </div>
        </div>

        {/* Total value */}
        <div className="mt-14 text-center bg-gold-500/5 border border-gold-500/20 rounded-2xl p-8" data-id="element-108">
          <p className="font-body text-gray-600 mb-2" data-id="element-109">
            Valor total de los bonos:
          </p>
          <p className="font-heading font-bold text-3xl text-gray-400 line-through mb-2" data-id="element-110">
            ARS $50,000
          </p>
          <p className="font-heading font-bold text-4xl text-green-600" data-id="element-111">
            ¡GRATIS HOY!
          </p>
        </div>
      </div>
    </section>;
}